/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Analysis_FailedInputs */

const en_ai_analysis_failed = /** @type {(inputs: Ai_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Analysis failed`)
};

const es_ai_analysis_failed = /** @type {(inputs: Ai_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis IA fallido`)
};

const fr_ai_analysis_failed = /** @type {(inputs: Ai_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'analyse IA`)
};

const de_ai_analysis_failed = /** @type {(inputs: Ai_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Analyse fehlgeschlagen`)
};

const ja_ai_analysis_failed = /** @type {(inputs: Ai_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI分析に失敗しました`)
};

const zh_ai_analysis_failed = /** @type {(inputs: Ai_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 分析失败`)
};

const ar_ai_analysis_failed = /** @type {(inputs: Ai_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل تحليل الذكاء الاصطناعي`)
};

const id_ai_analysis_failed = /** @type {(inputs: Ai_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisis AI gagal`)
};

const it_ai_analysis_failed = /** @type {(inputs: Ai_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi dell'IA non riuscita`)
};

const ru_ai_analysis_failed = /** @type {(inputs: Ai_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализ ИИ не удался`)
};

const pt_ai_analysis_failed = /** @type {(inputs: Ai_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na Análise de IA`)
};

const ko_ai_analysis_failed = /** @type {(inputs: Ai_Analysis_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 분석 실패`)
};

/**
* | output |
* | --- |
* | "AI Analysis failed" |
*
* @param {Ai_Analysis_FailedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_analysis_failed = /** @type {((inputs?: Ai_Analysis_FailedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Analysis_FailedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_analysis_failed(inputs)
	if (locale === "es") return es_ai_analysis_failed(inputs)
	if (locale === "fr") return fr_ai_analysis_failed(inputs)
	if (locale === "de") return de_ai_analysis_failed(inputs)
	if (locale === "ja") return ja_ai_analysis_failed(inputs)
	if (locale === "zh") return zh_ai_analysis_failed(inputs)
	if (locale === "ar") return ar_ai_analysis_failed(inputs)
	if (locale === "id") return id_ai_analysis_failed(inputs)
	if (locale === "it") return it_ai_analysis_failed(inputs)
	if (locale === "ru") return ru_ai_analysis_failed(inputs)
	if (locale === "pt") return pt_ai_analysis_failed(inputs)
	return ko_ai_analysis_failed(inputs)
});